import Vue from 'vue';
import Vuex from 'vuex';
import moment from 'moment';
// import bugsnagClient from '../bugsnag';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    meta: {
      title: null,
      description: '',
      breadcrumbs: [],
    },
    dashboard: {
      show_datepicker: false,
      interval: {
        date_from: moment().format('YYYY-MM-DD'),
        date_to: moment().format('YYYY-MM-DD'),
      },
    },
    logged: false,
    userLoading: false,
    userLoaded: false,
    Loaded: false,
    user: {
      id: null,
      name: '',
      email: '',
      user_type: null,
      profile_image: null,
      tutorial_viewed: false,
    },
    impersonation: false,
  },
  mutations: {
    setShowPicker: (state, value) => {
      state.dashboard.show_datepicker = value;
    },
    setDashboardPeriod: (state, payload) => {
      state.dashboard.interval.date_from = payload.date_from ? payload.date_from : null;
      state.dashboard.interval.date_to = payload.date_to ? payload.date_to : null;
    },
    setMeta: (state, payload) => {
      state.meta.title = payload.title ? payload.title : null;
      state.meta.description = payload.description ? payload.description : '';
      state.meta.breadcrumbs = payload.breadcrumbs ? payload.breadcrumbs : [];
    },
    setUserLoading: (state, value) => {
      state.userLoading = value;
    },
    setUserLoaded: (state) => {
      state.userLoaded = true;
    },
    setImpersonation: (state, value) => {
      state.impersonation = value;
    },
    setUser: (state, user) => {
      state.logged = true;
      state.user.uid = user.id;
      state.user.name = user.name;
      state.user.email = user.email;
      state.user.user_type = user.user_type;
      state.user.profile_image = user.profile_image;
      state.user.tutorial_viewed = user.tutorial_viewed;
      state.userLoaded = true;
      // bugsnagClient.user = state.user;
    },
    logout: (state) => {
      state.logged = false;
      state.impersonation = false;
      state.user = {
        id: null,
        name: '',
        email: '',
        phone: '',
        user_type: null,
        profile_image: null,
      };
    },
  },
  actions: {
    logout(context, { vm }) {
      vm.$auth.destroyToken();
      vm.$role.removePermissions();
      context.commit('logout', this);
      vm.$router.push({ name: 'login' });
      vm.$auth.destroyToken();
    },
  },
});
